import { useEffect, useRef } from "react";

export function useAutofocus() {
  let ref = useRef();

  useEffect(() => {
    ref.current.focus();
  }, []);

  return ref;
}
